<template>
  <el-dialog
    title="个性唛头模板编辑唛头"
    :visible="isShow"
    custom-class="temp-style"
    width="80%"
    :before-close="handleClose"
    destroy-on-close
  >
    <el-main
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    />
    <template v-else>
      <el-row>
        <h4>基础信息</h4>
        <el-form
          ref="formData"
          :inline="false"
          :model="formData"
        >
          <el-col
            v-for="(item, index) in baseMessageList"
            :key="index"
            :span="item.colSpan"
          >
            <el-form-item
              :label="`${item.fieldDisplayName}：`"
              :prop="item.fieldKey"
              label-width="120px"
              :rules="[
                {
                  required: item.attributeType === '输入框' && item.isRequired,
                  message: `${item.fieldDisplayName}不能为空`
                }
              ]"
            >
              <el-input
                v-if="item.attributeType === '输入框'"
                v-model="formData[item.fieldKey]"
                v-restrict-input="item.fieldDisplayName === '箱号' || item.fieldDisplayName === '送货单号' ? patter : null"
                placeholder="请输入"
              />
              <p v-else>
                {{ formData[item.fieldKey] }}
              </p>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div class="flex flex-align product-style">
        <h4>产品信息</h4>
      </div>
      <el-table
        ref="tableDataRef"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column fixed label="序号" align="left" type="index" />
        <el-table-column
          v-for="(item, index) in productHeaderList"
          :key="index"
          :prop="item.fieldKey"
          :label="item.fieldDisplayName"
          align="left"
          :min-width="item.fieldKey === 'customerInfo' ? 200 : 150"
          :render-header="(h, obj) => renderHeader(h, obj, item)"
        >
          <template slot-scope="scope">
            <el-input
              v-if="item.attributeType === '输入框'"
              v-model="scope.row[item.fieldKey]"
              v-restrict-input="item.fieldDisplayName === '系统单号' || item.fieldDisplayName === '（物料/套）描述' ? patter : null"
              :type="setInputType(item)"
              placeholder="请输入"
            />
            <ul v-else-if="item.fieldKey === 'customerInfo'" class="customer-info-style">
              <li v-for="(cItem, cIndex) in scope.row[item.fieldKey]" :key="cIndex">
                {{ cItem.title }}： {{ cItem.content }}
              </li>
            </ul>
            <span v-else>
              {{ scope.row[item.fieldKey] }}
            </span>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { parseTime } from '@/libs/util.js';
import { getMarkInfoData, markEditMark } from '@/API';
export default {
  data () {
    return {
      isShow: false,
      paramsIds: {},
      isLoading: false,
      formData: {},
      markInfoNum: '',
      selectList: [],
      baseType: 'markField',
      baseMessageList: [], // 基础信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [], // 产品信息数据
      numberForm: ['productNum', 'sheetNum', 'totalSheetNum'],
      patter: /[`~!@#$%^&*()_+=<>?:"{}|,.;'[\]·~！@#￥%……&*（）——+={}|《》？：“”【】、；‘’，。、]/g
    };
  },

  created () {
    // this.initData();
  },

  methods: {
    initData (params) {
      getMarkInfoData(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          // 基础信息的处理
          this.baseMessageList = (data.baseMessageList || []).map(item => {
            const val = () => {
              if (item.fieldKey === 'createTime') {
                return parseTime(new Date());
              } else if (item.fieldKey === 'createName') {
                return this.$store.state.user?.userName;
              }
              return item.defaultValue || '';
            };
            this.$set(this.formData, item.fieldKey, val());
            return {
              ...item,
              colSpan: ['remark'].indexOf(item.fieldKey) > -1 ? 24 : 8
            };
          });

          this.productHeaderList = (data.productHeaderList || []);
          this.tableData = (data.productValueList || []);
          this.markInfoNum = data.markInfoNum;
          this.markTemplateId = data.markTemplateId;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.handleClose();
        }
      }).catch(e => {
        this.isLoading = false;
      });
    },

    // 表头增加必填*符号
    renderHeader (h, { column }, item) {
      if (!item.isRequired) return column.label;
      return [
        h('span', { style: 'color: #f56c6c' }, '*'),
        h('span', ' ' + column.label)
      ];
    },

    // 提交
    handleSubmit () {
      let state = [];
      let baseForm = {};
      let productInfoList = [];
      // 产品信息的必填数据有哪些
      let productRequired = [];
      // 产品信息的必填状态
      let productRequiredStatus = [];

      // 基础信息的数据处理
      this.baseMessageList.forEach(item => {
        Object.keys(this.formData).forEach(j => {
          if (j === item.fieldKey) {
            baseForm[`${this.baseType}${item.fieldOrder}`] = this.formData[j];
          }
        });
        if (item.attributeType === '输入框' && item.isRequired) {
          state.push(baseForm[this.baseType + item.fieldOrder]);
        }
      });

      // 产品信息的数据处理
      this.productHeaderList.forEach(item => {
        if (item.attributeType === '输入框' && item.isRequired) {
          productRequired.push(`${item.fieldKey}`);
        }
        this.tableData.map(val => {
          Object.keys(val).forEach(key => {
            if (item.fieldKey === key) {
              val[`markProductField${item.fieldOrder}`] = val[key];
            }
          });
        });
      });

      // productInfoList 处理接口需要的数据格式
      productInfoList = this.tableData.map(val => {
        productRequired.forEach(item => {
          val[item] ? productRequiredStatus.push(1) : productRequiredStatus.push(0);
        });

        let obj = {};
        Object.keys(val).forEach(key => {
          if (key.includes('markProductField')) {
            obj[key] = val[key];
            obj.id = val.id;
          }
        });
        // 产品行需要补充的key集合
        let addKeyList = ['itemIndex', 'plmMarkBoxTotal', 'lastBoxTotal'];
        addKeyList.forEach(key => {
          obj[key] = val[key];
        });
        return obj;
      });
      const params = {
        markInfoNum: this.markInfoNum, // 唛头单据编号
        markTemplateId: this.markTemplateId, // 唛头模版Id
        markInfoId: this.paramsIds.markInfoId, // 唛头id
        partialId: this.paramsIds.partialId, // 发货列表id
        baseInformation: {
          ...baseForm,
          markInformationId: null
        },
        productInformation: productInfoList.map(i => {
          delete i.id;
          return {
            ...i
          };
        })
      };
      if (!state.every(item => item)) return this.$message.error('请输入必填项');
      if (!productRequiredStatus.every(item => item)) return this.$message.error('产品信息必填项请输入完成');

      markEditMark(params).then(res => {
        const { status } = res.data;
        if (status === '200') {
          this.$emit('setData');
          this.handleClose();
          this.$message.success('提交成功');
        }
      });
    },

    setInputType (item) {
      return this.numberForm.indexOf(item.fieldKey) > -1 ? 'number' : 'text';
    },

    openDialog (params) {
      this.paramsIds = params;
      this.isShow = true;
      this.isLoading = true;
      this.initData(params);
    },

    handleClose () {
      this.isShow = false;
      this.baseMessageList = [];
      this.productHeaderList = [];
      this.tableData = [];
    }
  }
};
</script>

<style lang="scss">
.temp-style {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .el-dialog__body {
    padding: 20px !important;
    min-height: 300px !important;
  }
  .el-main {
    min-height: 300px !important;
  }
}
</style>

<style lang="scss" scoped>
.temp-style {
  .flex {
    display: flex;
  }
  .flex-align {
    align-items: center;
  }
  .flex-1 {
    flex: 1;
  }
  .el-col {
    height: 40px;
  }
  h4 {
    margin: 10px 0;
  }
  .product-style {
    margin: 12px 0;
    .btn-style {
      margin-left: 20px;
    }
  }
  .customer-info-style{
    list-style: none;
    >li{
      text-align: left;
    }
  }
}
</style>
